export const EmailListConfigModel = {
	model: [
		{
			label: 'Provider',
			key: 'provider'
		},
		{
			label: 'Email',
			key: 'email',
		},
		{
			label: 'Created',
			key: 'created',
		},
		{
			label: 'Updated',
			key: 'updated',
		},
		{
			label: 'Created By',
			key: 'createdBy',
		},
	],

	formBuilderConfig: {
		provider: {
			DataType: 'Selector',
			UIControl: 'Dropdown',
			DisplayText: 'Provider',
			Name: 'provider',
			options: [],
			UIOptions: {
				ShowClearButton: true
			}
		},
		email: {
			DataType: 'String',
			DisplayText: 'email',
			Name: 'email',
			required: true
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'id',
			hidden: true,
			required: false
		},
		
	}
}
